var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { debugLog, parseOktaError, USERNAME_KEY, USERNAME_KEY_PARTIAL } from "@lululemon/auth-common";
import { setHashedEmail, setProfileField } from "@lululemon/mwa-profile";
import { CookieNames } from "./cookies";
import { getGuestInfo, loginWithAccessToken, setHttpOnlyRefreshToken, setTnc, updateSubscriberStatus } from "./graphql";
import { getLogger } from "./logger";
import { AuthClient } from "./okta-auth";
import { initializeJsReadyListener } from "./shape/initialize-js-ready-listener";
import { loadShapeScripts } from "./shape/load-shape-scripts";
import { isCypress, isLocalDev } from "./utils";
import { ERROR_THIRD_PARTY_COOKIE, REFRESH_TOKEN_INSPECTED_KEY } from "./utils/constants";
var THIRTY_MINUTES = 30 * 60 * 1000;
var logTags = {
    componentName: "auth-sdk",
    featureName: "auth-sdk"
};
// where localStorage is not supported, cookie will be used instead
// the main reason for removing sessionStorage option is making sure the magic link works on the same browser and different tab
var storageTypes = ["localStorage", "cookie"];
var AuthSdk = /** @class */ (function () {
    function AuthSdk(_a) {
        var app = _a.app, oktaConfig = _a.oktaConfig, _b = _a.env, env = _b === void 0 ? "prod" : _b;
        this.shapeLoadTime = Date.now();
        this.logger = getLogger({ app: app });
        if (!app) {
            this.logger.warn(new Error("app param is undefined. Logger wont attach logs to the right project."), { tags: logTags });
        }
        this.oktaConfig = __assign(__assign({}, oktaConfig), { storageManager: {
                token: {
                    storageTypes: storageTypes
                },
                cache: {
                    storageTypes: storageTypes
                },
                transaction: {
                    storageTypes: storageTypes
                }
            }, devMode: process.env.NODE_ENV === "development" });
        this.env = env;
    }
    Object.defineProperty(AuthSdk.prototype, "authClient", {
        get: function () {
            return AuthClient.getInstance({ config: this.oktaConfig, env: this.env });
        },
        enumerable: false,
        configurable: true
    });
    AuthSdk.prototype.renewTokens = function (refreshToken) {
        return __awaiter(this, void 0, void 0, function () {
            var refreshError;
            return __generator(this, function (_a) {
                if (typeof (refreshToken === null || refreshToken === void 0 ? void 0 : refreshToken.refreshToken) !== "string") {
                    refreshError = new Error("Non-string token is invalid or expired.");
                    refreshError.errorSummary = "Non-string token is invalid or expired.";
                    throw refreshError;
                }
                return [2 /*return*/, this.authClient.client.token.renewTokensWithRefresh({}, refreshToken)];
            });
        });
    };
    AuthSdk.prototype.renewTokensWithFallback = function (_a) {
        var _b;
        var fullRefreshToken = _a.fullRefreshToken, partialRefreshToken = _a.partialRefreshToken;
        return __awaiter(this, void 0, void 0, function () {
            var error_1, err;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _c.trys.push([0, 2, , 6]);
                        return [4 /*yield*/, this.renewTokens(fullRefreshToken)];
                    case 1: return [2 /*return*/, _c.sent()];
                    case 2:
                        error_1 = _c.sent();
                        err = parseOktaError(error_1);
                        if (!((_b = err === null || err === void 0 ? void 0 : err.toString()) === null || _b === void 0 ? void 0 : _b.includes("token is invalid or expired"))) return [3 /*break*/, 4];
                        // remove Full refreshToken so it doesn't get retried later somehow
                        return [4 /*yield*/, setHttpOnlyRefreshToken({
                                refreshToken: null,
                                cookieName: CookieNames.LLL_REF_FULL,
                                logger: this.logger
                            })];
                    case 3:
                        // remove Full refreshToken so it doesn't get retried later somehow
                        _c.sent();
                        return [2 /*return*/, this.renewTokens(partialRefreshToken)];
                    case 4: throw err;
                    case 5: return [3 /*break*/, 6];
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    AuthSdk.prototype.tryRefreshingSession = function (_a) {
        var _b, _c;
        var fullRefreshToken = _a.fullRefreshToken, partialRefreshToken = _a.partialRefreshToken;
        return __awaiter(this, void 0, void 0, function () {
            var tokens, error_2, err;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        _d.trys.push([0, 3, , 6]);
                        if (!fullRefreshToken && !partialRefreshToken) {
                            debugLog({ message: "Determined user is anonymous." });
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, this.renewTokensWithFallback({
                                fullRefreshToken: fullRefreshToken,
                                partialRefreshToken: partialRefreshToken
                            })];
                    case 1:
                        tokens = _d.sent();
                        if (!(tokens === null || tokens === void 0 ? void 0 : tokens.accessToken)) {
                            throw new Error("No okta accessToken received.");
                        }
                        return [4 /*yield*/, this.authOperationsForOktaTokens({ tokens: tokens })];
                    case 2:
                        _d.sent();
                        this.refreshStates();
                        return [3 /*break*/, 6];
                    case 3:
                        error_2 = _d.sent();
                        err = parseOktaError(error_2);
                        if (!((_b = err === null || err === void 0 ? void 0 : err.toString()) === null || _b === void 0 ? void 0 : _b.includes("token is invalid or expired"))) return [3 /*break*/, 5];
                        return [4 /*yield*/, setHttpOnlyRefreshToken({
                                refreshToken: null,
                                cookieName: CookieNames.LLL_REF_PART,
                                logger: this.logger
                            })];
                    case 4:
                        _d.sent();
                        _d.label = 5;
                    case 5:
                        (_c = this.logger) === null || _c === void 0 ? void 0 : _c.error(new Error("Error refreshing session. Reason: ".concat(err)), {
                            tags: __assign(__assign({}, logTags), { functionName: "tryRefreshingSession" })
                        });
                        throw error_2;
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    AuthSdk.prototype.authOperationsForOktaTokens = function (_a) {
        var tokens = _a.tokens, formName = _a.formName, orderId = _a.orderId, _b = _a.skipOrderMerge, skipOrderMerge = _b === void 0 ? false : _b;
        return __awaiter(this, void 0, void 0, function () {
            var _c, getGuestInfoResult, _d, firstName, email, tnc;
            return __generator(this, function (_e) {
                switch (_e.label) {
                    case 0: return [4 /*yield*/, this.storeTokens({ tokens: tokens })];
                    case 1:
                        _e.sent();
                        return [4 /*yield*/, Promise.allSettled([
                                getGuestInfo(this.logger),
                                loginWithAccessToken(__assign({ accessToken: tokens.accessToken, logger: this.logger, skipOrderMerge: skipOrderMerge }, (orderId !== undefined && { orderId: orderId })))
                            ])];
                    case 2:
                        _c = __read.apply(void 0, [_e.sent(), 1]), getGuestInfoResult = _c[0];
                        if (!((getGuestInfoResult === null || getGuestInfoResult === void 0 ? void 0 : getGuestInfoResult.status) === "fulfilled")) return [3 /*break*/, 4];
                        _d = ((getGuestInfoResult === null || getGuestInfoResult === void 0 ? void 0 : getGuestInfoResult.value) || {}).gihProfile, firstName = _d.firstName, email = _d.email, tnc = _d.tnc;
                        this.storeProfileData({ firstName: firstName, email: email });
                        if (!((tnc === null || tnc === void 0 ? void 0 : tnc.action) !== "Accepted" && formName !== "enroll-profile")) return [3 /*break*/, 4];
                        return [4 /*yield*/, this.setTncAccepted()];
                    case 3:
                        _e.sent();
                        _e.label = 4;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    AuthSdk.prototype.handlePostSignin = function (_a) {
        var tokens = _a.tokens, formName = _a.formName, _b = _a.skipOrderMerge, skipOrderMerge = _b === void 0 ? false : _b, orderId = _a.orderId, updateSubscriberStatusParams = _a.updateSubscriberStatusParams;
        return __awaiter(this, void 0, void 0, function () {
            var postSigninOperations;
            var _this = this;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        postSigninOperations = [
                            this.authOperationsForOktaTokens({
                                tokens: tokens,
                                formName: formName,
                                skipOrderMerge: skipOrderMerge,
                                orderId: orderId
                            }),
                            this.requestPartialTokens().then(function (partialTokensResult) {
                                return _this.storePartialTokens(partialTokensResult);
                            })
                        ];
                        if (updateSubscriberStatusParams === null || updateSubscriberStatusParams === void 0 ? void 0 : updateSubscriberStatusParams.isSubscribed) {
                            postSigninOperations.push(updateSubscriberStatus(__assign({}, updateSubscriberStatusParams)));
                        }
                        return [4 /*yield*/, Promise.allSettled(postSigninOperations)];
                    case 1:
                        _c.sent();
                        this.refreshStates();
                        return [2 /*return*/];
                }
            });
        });
    };
    AuthSdk.prototype.storeTokens = function (_a) {
        var _b;
        var tokens = _a.tokens;
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_c) {
                try {
                    if (!(tokens === null || tokens === void 0 ? void 0 : tokens.accessToken)) {
                        throw new Error("Missing accessToken to store.");
                    }
                    if (!(tokens === null || tokens === void 0 ? void 0 : tokens.refreshToken)) {
                        throw new Error("Missing refreshToken to store.");
                    }
                    this.authClient.setTokens(tokens);
                    // When storing tokens, remove cached check of HttpOnly cookies for anonymous users
                    localStorage === null || localStorage === void 0 ? void 0 : localStorage.removeItem(REFRESH_TOKEN_INSPECTED_KEY);
                }
                catch (error) {
                    (_b = this.logger) === null || _b === void 0 ? void 0 : _b.error(new Error("Error storing tokens. Reason: ".concat(error)), {
                        tags: __assign(__assign({}, logTags), { functionName: "storeTokens" })
                    });
                    throw error;
                }
                return [2 /*return*/];
            });
        });
    };
    AuthSdk.prototype.refreshStates = function () {
        var _a;
        (_a = window === null || window === void 0 ? void 0 : window.LLLNav) === null || _a === void 0 ? void 0 : _a.refreshNavState();
    };
    AuthSdk.prototype.requestPartialTokens = function () {
        var _a, _b, _c;
        return __awaiter(this, void 0, void 0, function () {
            var scopes, tokenResponse, tokens, error_3, isThirdPartyCookieError;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        _d.trys.push([0, 2, , 3]);
                        scopes = this.authClient.scopes.partial;
                        return [4 /*yield*/, this.authClient.client.token.getWithoutPrompt({
                                scopes: scopes
                            })];
                    case 1:
                        tokenResponse = _d.sent();
                        tokens = tokenResponse.tokens;
                        if (!(tokens === null || tokens === void 0 ? void 0 : tokens.refreshToken)) {
                            throw new Error("refreshToken is undefined.");
                        }
                        return [2 /*return*/, tokenResponse];
                    case 2:
                        error_3 = _d.sent();
                        isThirdPartyCookieError = !((_b = (_a = this.oktaConfig) === null || _a === void 0 ? void 0 : _a.issuer) === null || _b === void 0 ? void 0 : _b.includes(".lululemon.com")) &&
                            error_3.toString().includes(ERROR_THIRD_PARTY_COOKIE);
                        if (isThirdPartyCookieError) {
                            console.error("Partial tokens request failed due to Third Party Cookies error, continuing with Full session only: ", error_3);
                            return [2 /*return*/, { state: "", tokens: {} }];
                        }
                        (_c = this.logger) === null || _c === void 0 ? void 0 : _c.error(new Error("Error request and storing partial tokens. Reason: ".concat(parseOktaError(error_3))), {
                            tags: __assign(__assign({}, logTags), { functionName: "requestPartialTokens" })
                        });
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    AuthSdk.prototype.storePartialTokens = function (tokenResponse) {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function () {
            var partialTokenValue;
            return __generator(this, function (_c) {
                partialTokenValue = (_b = (_a = tokenResponse === null || tokenResponse === void 0 ? void 0 : tokenResponse.tokens) === null || _a === void 0 ? void 0 : _a.refreshToken) === null || _b === void 0 ? void 0 : _b.refreshToken;
                if (partialTokenValue) {
                    return [2 /*return*/, setHttpOnlyRefreshToken({
                            refreshToken: partialTokenValue,
                            expiresAt: this.authClient.getRefreshTokenExpiry("partial"),
                            logger: this.logger,
                            cookieName: CookieNames.LLL_REF_PART
                        })];
                }
                else {
                    return [2 /*return*/, { data: { setHttpOnlyCookie: null } }];
                }
                return [2 /*return*/];
            });
        });
    };
    /**
     * Shape script should be loaded before making Okta API calls. Once loaded, some headers will be attched to
     * request headers which are needed by Shape security to eliminate blocking requests.
     */
    AuthSdk.prototype.prepareShape = function (params) {
        return __awaiter(this, void 0, void 0, function () {
            var timeout, response, jsReadyPromise, loadScriptsPromise, jsReadyResult, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (isLocalDev() || isCypress()) {
                            return [2 /*return*/, Promise.resolve({ cleanup: function () { } })];
                        }
                        // If Shape has expired, force reload
                        if (this.isShapeExpired()) {
                            params.forceReload = true;
                        }
                        timeout = params.timeout || 5000;
                        if (!params.shouldUseJSReadyEvent) return [3 /*break*/, 4];
                        jsReadyPromise = initializeJsReadyListener({
                            timeout: timeout,
                            logger: this.logger
                        });
                        loadScriptsPromise = loadShapeScripts(__assign(__assign({}, params), { timeout: timeout, logger: this.logger }));
                        return [4 /*yield*/, jsReadyPromise];
                    case 1:
                        jsReadyResult = _b.sent();
                        _a = jsReadyResult;
                        if (_a) return [3 /*break*/, 3];
                        return [4 /*yield*/, loadScriptsPromise];
                    case 2:
                        _a = (_b.sent());
                        _b.label = 3;
                    case 3:
                        response = _a;
                        debugLog({
                            message: "Shape readiness determined by ".concat(jsReadyResult ? "JSReady" : "MO")
                        });
                        return [3 /*break*/, 6];
                    case 4: return [4 /*yield*/, loadShapeScripts(__assign(__assign({}, params), { timeout: timeout, logger: this.logger }))];
                    case 5:
                        response = _b.sent();
                        _b.label = 6;
                    case 6:
                        // Once Shape has loaded, save the time
                        if (params.forceReload) {
                            this.shapeLoadTime = Date.now();
                        }
                        return [2 /*return*/, response];
                }
            });
        });
    };
    // Check if it has been more than 30 mins since Shape was loaded
    AuthSdk.prototype.isShapeExpired = function () {
        var elapsedTime = Date.now() - this.shapeLoadTime;
        return elapsedTime > THIRTY_MINUTES;
    };
    AuthSdk.prototype.storeProfileData = function (_a) {
        var firstName = _a.firstName, email = _a.email;
        if (firstName) {
            setProfileField("firstName", firstName);
        }
        if (email) {
            setHashedEmail(email);
        }
    };
    AuthSdk.prototype.setTncAccepted = function () {
        return __awaiter(this, void 0, void 0, function () {
            var oktaId, accessToken;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.authClient.getOktaId()];
                    case 1:
                        oktaId = _a.sent();
                        return [4 /*yield*/, this.authClient.getAccessToken()];
                    case 2:
                        accessToken = _a.sent();
                        return [4 /*yield*/, setTnc({
                                oktaId: oktaId,
                                accessToken: accessToken,
                                action: "Accepted",
                                logger: this.logger
                            })];
                    case 3:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    AuthSdk.getIdentifier = function (key) {
        key = key || "";
        try {
            return ((localStorage === null || localStorage === void 0 ? void 0 : localStorage.getItem(key)) ||
                (localStorage === null || localStorage === void 0 ? void 0 : localStorage.getItem(USERNAME_KEY_PARTIAL)) ||
                (localStorage === null || localStorage === void 0 ? void 0 : localStorage.getItem(USERNAME_KEY)) ||
                undefined);
        }
        catch (error) {
            return undefined;
        }
    };
    AuthSdk.setIdentifier = function (key, value) {
        try {
            return localStorage === null || localStorage === void 0 ? void 0 : localStorage.setItem(key, value);
        }
        catch (error) {
            return undefined;
        }
    };
    AuthSdk.removeIdentifiers = function (keys) {
        var defaultKeys = [USERNAME_KEY, USERNAME_KEY_PARTIAL];
        try {
            (keys || defaultKeys).forEach(function (key) {
                localStorage === null || localStorage === void 0 ? void 0 : localStorage.removeItem(key);
            });
        }
        catch (error) {
            return undefined;
        }
    };
    return AuthSdk;
}());
export { AuthSdk };
export default AuthSdk;
